import { CosmosBadge } from "@cosmos/web-react";
import classNames from "classnames/bind";
import styles from "./TagsList.module.css";

const cx = classNames.bind(styles);

export function TagsList({
  className,
  tags,
}: {
  tags: string[];
  className?: string;
}) {
  return (
    <ul className={cx("container", className)} role="list">
      {tags.map((value) => (
        <li key={value} className={cx("contentTag")}>
          <CosmosBadge shape="rectangle" kind="primary" size="medium">
            {value}
          </CosmosBadge>
        </li>
      ))}
    </ul>
  );
}
